import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { CoreModule } from '../core.module';
import { UserService } from '../services/data/user.service';

@Injectable({
	providedIn: CoreModule,
})
export class GuestGuard {
	constructor(
		private userService: UserService,
		private router: Router,
	) {

	}

	//Redirect to author version if logged in.
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.userService.loggedIn) {
			const urlTree = this.router.parseUrl(state.url);

			const targetSegments = urlTree.root.children.primary?.segments.map((s) => s.path) || [];
			const { queryParams } = urlTree;
			this.router.navigate(
				['/author-dashboard', this.userService.me.authorLink, ...targetSegments],
				{ queryParams },
			);

			return false;
		}

		return true;
	}
}
